import { Stethoscope } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-foreground text-background py-12 sm:py-16"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="w-10 h-10 rounded-2xl bg-primary text-primary-foreground grid place-items-center">
              <Stethoscope className="w-5 h-5" strokeWidth={2.4} />
            </span>
            <span className="font-heading font-bold text-xl">
              Ayushman Distributors
            </span>
          </div>
          <p className="mt-4 text-sm text-background/70 leading-relaxed max-w-md">
            A pediatric-focused pharmaceutical marketing & distribution enterprise.
            Pediarange® is our specialised product family for children's nutrition,
            immunity and gut wellness.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-heading font-semibold text-sm uppercase tracking-wider mb-4 text-background/90">
            Products
          </p>
          <ul className="space-y-2 text-sm text-background/70">
            <li>SUNPOP Plus</li>
            <li>SUNPOP-800 D3 Drops</li>
            <li>GUTPOP Suspension</li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-heading font-semibold text-sm uppercase tracking-wider mb-4 text-background/90">
            Compliance
          </p>
          <ul className="space-y-2 text-sm text-background/70">
            <li>
              <span className="text-background/50">GSTIN:</span> 09CIFPG1140N2Z8
            </li>
            <li>
              <span className="text-background/50">Udyam:</span> UDYAM-UP-28-0119072
            </li>
            <li>
              <span className="text-background/50">Phone:</span>{" "}
              <a
                href="tel:+918708159671"
                className="hover:text-primary-foreground"
                data-testid="footer-phone"
              >
                +91 87081 59671
              </a>
            </li>
            <li>
              <span className="text-background/50">Email:</span>{" "}
              <a
                href="mailto:ayushayush921@gmail.com"
                className="hover:text-primary-foreground underline"
              >
                ayushayush921@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-10 pt-6 border-t border-background/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-background/60">
        <p>© {year} Ayushman Distributors. All rights reserved.</p>
        <p>Pediarange® is a product line of Ayushman Distributors.</p>
      </div>
    </footer>
  );
};

export default Footer;
